import React from "react";

const MenuSeparator = () => (
  <div
    style={{
      height: "1px",
      backgroundColor: "var(--default-border-color)",
      margin: ".5rem 0",
    }}
  />
);

export default MenuSeparator;
MenuSeparator.displayName = "DropdownMenuSeparator";
